/* ============================================================
   MICTLÁN — Piezas propias del carrito lateral
   (snippets/cart-drawer.liquid → mx-carrito-extras / recomendaciones)
   ============================================================
   Horizon re-renderiza el carrito de dos formas:
   · morph de .cart-drawer__inner (cambiar cantidad, eliminar, agregar
     desde la ficha). OJO: data-skip-node-update solo protege los
     atributos del nodo; morph.js SÍ recorre sus hijos y los deja como
     vienen del servidor. Por eso, tras cada morph, el carrusel de
     testimonios queda sin flechas ni pista y las sugerencias quedan
     vacías (bug visto el 12 oct 2026).
   · assets/mx-carrito.js sustituye todo <cart-drawer-component> tras
     agregar desde una tarjeta: los nodos son nuevos.

   Solución: después de cualquier cambio dentro del carrito (observador
   de mutaciones sobre #cart-drawer) se revisa el estado y se repara:

   [data-amatora-slider] sin inicializar → se vuelve a inicializar.
   <mx-carrito-recos data-url>            → si quedó vacío, se vuelve a
                                            llenar (de la caché si ya se
                                            pidió esa URL; la URL cambia
                                            con el primer producto).
   Cada reparación deja el estado correcto, así que no se repite en bucle.

   Clic en «Eliminar» del último producto: Horizon cambia el contenido por
   el carrito vacío y, cuando el clic llega al <dialog>, el botón ya no
   está en la página; theme-drawer.js lo toma como clic afuera y cierra el
   panel. Un clic cuyo destino ya se desconectó no sigue subiendo.
   ============================================================ */
(function () {
  'use strict';

  /** URL → HTML de las sugerencias ('' = Shopify no tiene) */
  var cache = {};
  var pendientes = {};

  function repararSliders(raiz) {
    if (!window.SliderAmatora || typeof window.SliderAmatora.initAll !== 'function') return;
    var sliders = raiz.querySelectorAll('[data-amatora-slider]');
    for (var i = 0; i < sliders.length; i++) {
      var el = sliders[i];
      var armado = el.dataset.amatoraSliderInit === '1' && el.querySelector('.slider-amatora__track');
      if (armado) continue;
      var viejo = window.SliderAmatora.get && window.SliderAmatora.get(el);
      if (viejo) viejo.destroy();
      el.dataset.amatoraSliderInit = '';
      window.SliderAmatora.initAll(el.parentElement);
    }
  }

  function pintarRecos(el, html) {
    if (!html) {
      el.hidden = true;
      return;
    }
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var listo = tmp.querySelector('[data-mx-recos-listo]');
    if (!listo) {
      el.hidden = true;
      return;
    }
    el.replaceChildren(listo);
    el.hidden = false;
    repararSliders(el);
  }

  function repararRecos(raiz) {
    var lista = raiz.querySelectorAll('mx-carrito-recos[data-url]');
    for (var i = 0; i < lista.length; i++) {
      var el = lista[i];
      var url = el.dataset.url;
      if (el.querySelector('[data-mx-recos-listo]')) continue; // ya está lleno

      if (url in cache) {
        pintarRecos(el, cache[url]);
        continue;
      }
      if (pendientes[url]) continue;
      pendientes[url] = true;
      fetch(url)
        .then(function (r) {
          return r.ok ? r.text() : '';
        })
        .catch(function () {
          return '';
        })
        .then(
          function (u) {
            return function (html) {
              var tmp = document.createElement('div');
              tmp.innerHTML = html;
              cache[u] = tmp.querySelector('[data-mx-recos-listo]') ? html : '';
              delete pendientes[u];
              revisar();
            };
          }(url)
        );
    }
  }

  function noCerrarAlQuitar(drawer) {
    var comp = drawer.querySelector('cart-drawer-component');
    if (!comp || comp._mxClic) return;
    comp._mxClic = true;
    comp.addEventListener('click', function (e) {
      if (e.target instanceof Node && !e.target.isConnected) e.stopPropagation();
    });
  }

  function revisar() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    noCerrarAlQuitar(drawer);
    repararSliders(drawer);
    repararRecos(drawer);
  }

  var programado = false;
  function revisarPronto() {
    if (programado) return;
    programado = true;
    // Una vez por frame aunque el morph dispare cientos de mutaciones.
    requestAnimationFrame(function () {
      programado = false;
      revisar();
    });
  }

  function observar() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    new MutationObserver(revisarPronto).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-url', 'data-amatora-slider-init'] });
    revisar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observar);
  } else {
    observar();
  }
})();
